export const DefaultDashboardName = 'Dashboard 1';
